import './AgentTerminated.scss'

import React from 'react'
import moment from 'moment-timezone'

export const AgentTerminated = ({ terminatedAt }) => (
  <div className="AgentTerminated">
    <div>Agent Terminated</div>
    <div>
      { moment.utc(terminatedAt).local().format("MM/DD/YY") }
    </div>
  </div>
)
